<template>
    <div>
        <b-button @click.stop="printStart()" :variant="btn_variant" :size="btn_size">
            <slot></slot>
        </b-button>
        <div v-if="print_stage >= 2"
             style="margin-left:-9999px; margin-top:-9999px; width: 1100px; position:fixed;" :key="start_key">
            <div id="printout" class="printing px-5">

                <div class="d-flex align-items-center justify-content-between" style="height:80px;">
                    <b-img src="/images/QuantifiedESG_Logo_v3_Basic.svg" style="width: 110px;"></b-img>
                    <div class="gray-600 f-90"> QESG Assessment <span v-if="!is_current_question">/ {{ $store.state.company_name }}</span></div>
                </div>
                <h2 class="fw-600 mb-5 py-5 px-5 teal8 bg-tealgray200" v-if="!is_current_question">
                    <template v-if="print_title">
                        {{ print_title }} {{ $i18n.locale === 'ko' ? '질문지' : 'Questionnaire' }}
                    </template>
                    <template v-else>
                        <template v-if="$i18n.locale === 'ko'">
                            {{ campaign_in_progress.campaign_name }} {{ $t('질문지') }}
                        </template>
                        <template v-if="$i18n.locale === 'en'">
                            {{ campaign_in_progress.campaign_name_e }} {{ $t('질문지') }}
                        </template>
                        <template v-if="$i18n.locale === 'ca'">
                            {{ campaign_in_progress.campaign_name_c ?? campaign_in_progress.campaign_name_e }}
                            {{ $t('질문지') }}
                        </template>
                    </template>
                </h2>
                <hr class="border-0 py-3">
                <div v-for="(question_code_item, index) in print_target_questions"
                     :key="`print-questions-${question_code_item}-${question_code_item.id}`"
                >
                    <questions-for-print
                        class="text-left"
                        @load-finished="handleLoadFinished"
                        :no_answers="no_answers"
                        :question_code="question_code_item"
                        :is_final_question_code="index === print_target_questions.length-1"
                        :view_pipe_line="view_pipe_line"
                    >
                    </questions-for-print>
                </div>
                <div v-if="!is_hyundai" class="px-8 py-5 bgray-300">
                    <div class="f-85 mb-3" :class="$i18n.locale=='en'?'':'pt-3'">
                        <div class="fw-300 mb-2">{{ $t(`copyright 2024. ㈜퀀티파이드이에스지, all rights reserved.`) }}</div>
                        <div class="fw-300 mb-2">
                            {{ $t(`본 문서에 게재된 평가 질문 문항 정보, 질문지 레이아웃을 포함한 모든 정보는 저작권법에 의하여 보호받는 저작물로 그 저작권은 ㈜퀀티파이드이에스지에 있습니다. 따라서 본 보고서에 대한 무단 복제, 전체, 배포를 원칙적으로 금지합니다. 또한 본 문서를 통해 수익을 얻거나 이에 상응하는 혜택을 누리고자 하는 경우 ㈜퀀티파이드이에스지와 사전에 별도 서면 협의를 거쳐야 하며, 협의가 완료된 후에도 해당 보고서의 내용을 게재하는 경우 출처가 ㈜퀀티파이드이에스지임을 밝혀야 합니다.`) }}
                        </div>
                        <div class="fw-300 ">
                            <template v-if="$i18n.locale=='ko'">본 문서에 게재된 정보 또는 위와 관련한 사항에 대한 보다 자세한 정보는 <a
                                href="http://qesg.co.kr/" target="_blank">qesg.co.kr</a>에 문의해 주십시오.
                            </template>
                            <template v-else>Please contact <a href="http://qesg.co.kr/" target="_blank">qesg.co.kr</a>
                                for more detailed information on the information presented in this report or related to
                                the above.
                            </template>
                        </div>
                    </div>
                    <div class="text-right">
                        <b-img src="/images/QuantifiedESG_Logo_v3_Basic.svg" style="width: 110px;"></b-img>
                    </div>
                </div>
            </div>
        </div>

        <b-modal :id="modal_id" size="lg" hide-footer
                 no-close-on-backdrop
                 no-close-on-esc
                 no-enforce-focus
        >
            <template v-slot:modal-header>
                <span> {{ $t(`인쇄/다운로드`) }}</span>
                <b-button-close @click="cancel"/>
            </template>
            <div class="d-block text-center">

                <!-- <div class="text-left">진행률 </div> -->
                <!--<div> 전체 개수: {{ num_of_print_target_questions }}</div>
                <div> load 시작 개수: {{ num_of_print_target_questions_started }} </div>
                <div> load 완료 개수: {{ num_of_print_target_questions_loaded }} </div>-->
                <template v-if="print_stage === 2">
                    <div class="pb-3">
                        <b-progress :value="progress_rate" :max="100" animated/>
                    </div>
                    <div>
                        <div class="d-flex align-items-center justify-content-center">
                            <b-spinner small class="mr-2" type="grow"></b-spinner>
                            {{ msg }}
                        </div>
                    </div>
                </template>
                <div v-if="print_stage === 3" class="mt-3">
                    <p class="text-left fw-500"> {{ $t(`PDF로 다운로드 하실 경우 아래 설명을 확인 후 진행해 주세요.`) }}</p>

                    <b-tabs content-class="bg-white pt-3">
                        <b-tab :title="$t(`크롬(Google Chrome) 사용중인 경우`)" active>
                            <b-img
                                :src="$i18n.locale=='en'?'/images/how_to_print_chrome_en.png':'/images/how_to_print_chrome.png'"
                                fluid style="max-width: 90%"></b-img>
                        </b-tab>
                        <b-tab :title="$t(`엣지(Microsoft Edge) 사용중인 경우`)">
                            <b-img
                                :src="$i18n.locale=='en'?'/images/how_to_print_edge_en.png':'/images/how_to_print_edge.png'"
                                fluid style="max-width: 90%"></b-img>
                        </b-tab>
                    </b-tabs>

                    <!--<b-button @click="pdf.save('download.pdf')">다운로드</b-button>-->
                    <b-button v-if="isIE!==true" v-print="'#printout'" variant="blue" class="mt-3">
                        {{ $t(`인쇄 / PDF 다운로드`) }}
                    </b-button>
                    <b-button v-else @click="pdf.save('company_report.pdf')" variant="blue">{{ $t(`PDF 다운로드`) }}
                    </b-button>
                </div>
            </div>
            <b-button
                      class="float-right" @click="cancel()" variant="dark">{{ $t(`취소`) }}
            </b-button>
        </b-modal>
    </div>
</template>
<script>
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import QuestionsForPrint from '@core_components/common/QuestionsForPrint'
import * as th from 'tree-helper'
import {mapActions, mapState} from 'vuex'
import {check_is_hyundai} from "@core_utils/check-app-env";

export default {
    name: 'pdf',
    props: {
        no_answers: {
            type: Boolean,
            default: false,
        },
        btn_size: {
            type: String,
            default: ''
        },
        btn_variant: {
            type: String,
            default: 'dark-border'
        },
        data_prepared: {
            type: Boolean,
            default: true
        },
        view_pipe_line: {
            type: Boolean,
            default: true,
        },
        modal_id: {
            type: String,
            default: 'pdf_down_modal'
        },
        print_title: {
            type: String,
            default: null,
        },
        is_current_question: {
            type: Boolean,
            default: false
        }
    },
    components: {
        QuestionsForPrint
    },
    data() {
        return {
            print_target_questions: [],
            start_key: 1011,
            propTitle: 'mypdf',
            pdf: '',
            print_target_questions_started: [],
            print_target_questions_loaded: [],
            msg: this.$t(`PDF 파일 준비중... 최대 1분 정도 소요될 수 있습니다.`),
            /** print_stage
             * 1: idle - 초기 상태
             * 2: fetching - subs api 순회 조회 중
             * 3: loaded - subs api 조회 완료
             */
            print_stage: 1,
        }
    },
    computed: {
        ...mapState(['is_admin']),
        ...mapState('industry_campaigns', ['custom_project_code', 'custom_template', 'custom_template_loaded']),
        num_of_print_target_questions() {
            return this.print_target_questions.length
        },
        num_of_print_target_questions_loaded() {
            return this.print_target_questions_loaded.length
        },
        progress_rate() {
            return (this.num_of_print_target_questions_loaded / this.num_of_print_target_questions) * 100
        },
        campaign_in_progress() {
            return this.$store.state.campaign_in_progress
        },
        is_hyundai() {
            const campaign_id = this.$route.query.cmp ?? this.campaign_in_progress.campaign_id
            return check_is_hyundai(campaign_id)
        }
    },
    watch: {
        async progress_rate(new_value) {
            if (new_value >= 100) {
                if (this.isIE === true) {
                    this.pdf = await this.makePDF('#printout')
                }
                clearTimeout(this.print_timeout)
                this.msg = `출력 준비가 완료되었습니다.`
                this.print_stage = 3
            }
        },
        data_prepared(value) {
            if (value) {
                this.printStart()
            }
        }
    },
    created() {
        this.initializePrintButton()
    },
    beforeDestroy() {
        this.initializePrintButton()
    },
    methods: {
        handleLoadFinished(question_code) {
            // 취소/초기화 이후 늦게 도착한 완료 이벤트는 무시한다
            if (this.print_stage !== 2) return
            this.print_target_questions_loaded.push(question_code)
            if (question_code == this.print_target_questions[this.print_target_questions.length - 1]) {
                while (this.progress_rate < 100) {
                    this.print_target_questions_loaded.push('dummy')
                }
            }
        },
        makePDF(sel) {
            window.html2canvas = html2canvas //Vue.js 특성상 window 객체에 직접 할당해야한다.
            // let that = this
            let pdf = new jsPDF('p', 'mm', 'a4')
            let canvas = pdf.canvas
            const pageWidth = 210 //캔버스 너비 mm
            const pageHeight = 295 //캔버스 높이 mm
            canvas.width = pageWidth

            let ele = document.querySelector(sel)
            let width = ele.offsetWidth // 셀렉트한 요소의 px 너비
            let height = ele.offsetHeight // 셀렉트한 요소의 px 높이
            let imgHeight = pageWidth * height / width // 이미지 높이값 px to mm 변환

            if (!ele) {
                console.warn(sel + ' is not exist.')
                return false
            }

            return html2canvas(ele)
                .then(function (canvas) {
                    let position = 0
                    const imgData = canvas.toDataURL('image/png')
                    pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight, undefined, 'slow')

                    //Paging 처리
                    let heightLeft = imgHeight //페이징 처리를 위해 남은 페이지 높이 세팅.
                    heightLeft -= pageHeight
                    while (heightLeft >= 0) {
                        position = heightLeft - imgHeight
                        pdf.addPage();
                        pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight)
                        heightLeft -= pageHeight
                    }

                    return pdf
                })
        },
        printStart() {
            if (!this.data_prepared) {
                this.$emit('prepare_print_data')
                return
            }
            this.initiatePrintTargetQuestions()
            if (this.print_target_questions.length === 0) {
                this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('출력할 질문이 없습니다.'))
                return
            }
            this.$bvModal.show(this.modal_id)
            this.print_stage = 2

            this.print_target_questions_started = []
            this.print_target_questions_loaded = []
            // 로딩이 끝나지 않는 경우 사용자가 알 수 있게 한다 (취소 버튼은 항상 노출)
            this.print_timeout = setTimeout(() => {
                if (this.print_stage === 2) {
                    this.msg = this.$t('출력 준비가 지연되고 있습니다. 취소 후 다시 시도해주세요.')
                }
            }, 60000)

        },
        initializePrintButton() {
            clearTimeout(this.print_timeout)
            this.$bvModal.hide(this.modal_id)
            this.print_target_questions = []
            this.start_key = 1011
            this.propTitle = 'mypdf'
            this.pdf = ''
            this.print_target_questions_started = []
            this.print_target_questions_loaded = []
            this.msg = this.$t(`PDF 파일 준비중... 최대 1분 정도 소요될 수 있습니다.`)
            this.ignorePipeline = false
            this.print_stage = 1
        },
        cancel() {
            this.initializePrintButton()
            this.$bvModal.hide(this.modal_id)
        },
        initiatePrintTargetQuestions() {
            this.print_target_questions = []
            let template_contents = this.$store.state.template_in_progress.template_contents
            let temp_print_target = []
            th.breadthFirstSearch(template_contents, node => {
                if (typeof node.children == 'undefined' || node.children.length == 0) {
                    if (this.is_current_question) {
                        if (this.is_current_question && node.question_code === this.$route.query.question_id) {
                            temp_print_target.push(node.question_code)
                        }
                    } else {
                        temp_print_target.push(node.question_code)
                    }
                }
            })
            // console.log(temp_print_target);
            // if(this.project_code!=''&&this.project_code=='hdec001'&&this.custom_template_loaded==true){
            //     let custom_template_contents = this.custom_template.template_contents
            //     // console.log(custom_template_contents);
            //     th.breadthFirstSearch(custom_template_contents, node => {
            //         if(node.children == undefined || node.children.length == 0){
            //             // console.log(node.question_code);
            //             temp_print_target.push(node.question_code)
            //         }
            //     })
            //     // console.log(temp_print_target);
            // }
            // console.log(temp_print_target);
            this.print_target_questions = temp_print_target
        }
    }
}
</script>
<style scoped>
.printing {
    display: block;
}
</style>
